






































import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { MedTransGoConstants } from '@/util/constants';
import { ObjectFactory } from '@/config/objectFactory';
import { ApiRequest } from '@/types/request';
import { ToastEvent } from '@/types/event';
import { EventBus } from '@/main';
import { CommonUtils } from '@/util/commonUtils';

@Component({
    mixins: [validationMixin],
    props: {
        transportId: String,
    },
    data() {
        return {
            driversExcel: {
                file: FormData,
                filename: '',
            },
        };
    },
    validations: {
        driversExcel: {
            filename: {
                required,
            },
        },
    },
})
export default class UploadDriverModal extends Vue {
    private show = true;
    private showDeleteConfirmBox = false;

    private async setExcel($event: any) {
        const filename = $event.target.files[0].name.toLowerCase();
        if (filename.endsWith('.xlsx')) {
            this.$data.driversExcel.file = $event.target.files[0];
            this.$data.driversExcel.filename = $event.target.files[0].name;
        } else {
            const toastEvent: ToastEvent = {
                message: 'File types should be xlsx',
                title: 'Invalid file format.',
                varient: 'danger',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            const inputName = 'file-input-1';
            const element = this.$refs[inputName] as any;
            element.reset();
        }
    }
    private async uploadDrivers() {
        const excelFormData = new FormData();
        excelFormData.append('file', this.$data.driversExcel.file);
        excelFormData.append('transporterId', this.$props.transportId);
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/driver/upload`,
            data: excelFormData,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<any>(apiRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: 'You will get a confirmation email after excel is processed.',
                title: 'Success!',
                varient: 'success',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.$emit('success');
            this.close();
        } else {
            CommonUtils.showError(response);
        }
    }
    private close() {
        this.$emit('close');
    }
}
